import { useEffect, useState } from "react";
import RightBrandingPanel from "./RightBrandingPanel";
import { WISHLINK_AUTH_WORDMARK_LOGO_URL } from "../utils/constants";
import { Box } from "@mui/material";

const getViewportWidth = () => {
  if (typeof window === "undefined") {
    return 1440;
  }
  return window.innerWidth;
};

// footer: shown centred at the very bottom of the form column (e.g. a contact line), full column width.
export default function AuthLayout({ children, footer }) {
  const [viewportWidth, setViewportWidth] = useState(getViewportWidth());

  useEffect(() => {
    const onResize = () => setViewportWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const isStackedLayout = viewportWidth < 980;

  const authLayoutStyle = {
    margin: "0 auto",
    width: "100%",
    height: isStackedLayout ? "auto" : "100%",
    minHeight: isStackedLayout ? "100vh" : 0,
    display: "flex",
    alignItems: "stretch",
    boxSizing: "border-box",
    flexDirection: isStackedLayout ? "column" : "row",
  };

  const rightPanelOuterStyle = isStackedLayout
    ? {
        width: "100%",
        maxWidth: 760,
        padding: "16px",
        boxSizing: "border-box",
      }
    : {
        flex: "0 0 min(696px, 45%)",
        width: "min(696px, 45%)",
        minHeight: 0,
        padding: "16px",
        boxSizing: "border-box",
        display: "flex",
        // The panel fits the window height itself; it never scrolls.
        overflow: "hidden",
      };

  return (
    <Box
      sx={{
        height: isStackedLayout ? "auto" : "100vh",
        minHeight: "100vh",
        overflow: isStackedLayout ? "auto" : "hidden",
        background: "#ffffff",
      }}
    >
      <Box sx={authLayoutStyle}>
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            p: "48px 16px 0 16px",
            boxSizing: "border-box",
            overflow: isStackedLayout ? "visible" : "hidden",
          }}
        >
          <Box
            component="img"
            src={WISHLINK_AUTH_WORDMARK_LOGO_URL}
            alt="Wishlink logo"
            sx={{ width: 104, height: 24, objectFit: "contain", flexShrink: 0 }}
          />
          <Box
            sx={{
              width: "100%",
              maxWidth: 484,
              mt: "48px",
              pb: 2,
              flexShrink: 1,
              minHeight: 0,
              overflowY: isStackedLayout ? "visible" : "auto",
              maxHeight: isStackedLayout
                ? "none"
                : `calc(100vh - 48px - 24px - 48px${footer ? " - 48px" : ""})`,
              scrollbarWidth: isStackedLayout ? undefined : "none",
              msOverflowStyle: isStackedLayout ? undefined : "none",
              "&::-webkit-scrollbar": isStackedLayout
                ? undefined
                : { display: "none" },
            }}
          >
            {children}
          </Box>
          {footer && (
            <Box
              sx={{
                mt: "auto",
                pt: 2,
                pb: "24px",
                width: "100%",
                flexShrink: 0,
                textAlign: "center",
              }}
            >
              {footer}
            </Box>
          )}
        </Box>
        <Box sx={rightPanelOuterStyle}>
          <RightBrandingPanel fitHeight={!isStackedLayout} />
        </Box>
      </Box>
    </Box>
  );
}
